// core
import React from "react";

import CashbackSpecialOffer from "./SpecialOffers/CashbackSpecialOffer";
import { SpecialOffer } from "../../../../enums/SpecialOffer";
import AsteronPrezzyCardSpecialOffer from "./SpecialOffers/AsteronPrezzyCardSpecialOffer";
import CignaTraumaTwoYearsFreeSpecialOffer from "./SpecialOffers/CignaTraumaTwoYearsFreeSpecialOffer";
import Icon from "../../../../../common/components/Icon/Icon";
import useLightwindow from "../../../../../common/hooks/useLightwindow";


interface ISpecialOfferProps {
    name: string;
    cashbackAmount: number;
}

const QuoteSpecialOffers: React.FC<ISpecialOfferProps> = (props) => {
    const { name, cashbackAmount } = props;

    const lowerName = name.toLowerCase();

    const { openPromotion } = useLightwindow();

    if (lowerName.endsWith("_holiday_pack")) {
        return <React.Fragment>Life Direct Holiday Pack</React.Fragment>;
    }

    switch (lowerName) {
        case SpecialOffer.CashBack20.toLowerCase():
        case SpecialOffer.Cashback30.toLowerCase(): {
            return <CashbackSpecialOffer amount={cashbackAmount} />;
        }

        case SpecialOffer.nibPreExistingConditions.toLowerCase():
            return (
                <a onClick={() => openPromotion("NibPreExisting")}>
                    Pre-existing conditions offer
                </a>
            );

        case SpecialOffer.AIAOneMonthFree.toLowerCase():
            return (
                <a onClick={() => openPromotion("AIA1MonthFree")}>
                    One month free
                </a>
            );
        case SpecialOffer.ChubbTwoMonthsFree.toLowerCase():
            return (
                <a onClick={() => openPromotion("ChubbTwoMonthsFree")}>Two months free</a>
            );

        case SpecialOffer.AsteronLifePrezzy.toLowerCase():
            return <AsteronPrezzyCardSpecialOffer />;

        // Relates to latest version of offer, specified in SpecialOffer enum
        case SpecialOffer.nibTwoMonthsFree.toLowerCase():
            return (
                <a onClick={() => openPromotion("NibTwoMonthsFree")}>Two months free</a>
            );

        case SpecialOffer.nibMentalHealthBenefit.toLowerCase():
            return (
                <a onClick={() => openPromotion("NibMentalHealthBenefit")}>Complementary 12 month mental health benefit</a>
            );

        case SpecialOffer.nibHealthDiscount10.toLowerCase():
            return (
                <a onClick={() => openPromotion("NibHealthDiscount")}>10% off health cover for 12 months</a>
            );

        case SpecialOffer.nibLifeLiving.toLowerCase():
            return (
                <a onClick={() => openPromotion("nibLifeLiving")}>$200 off Life & Living products</a>
            );

        case SpecialOffer.CignaTraumaTwoYearsFree.toLowerCase():
            return <CignaTraumaTwoYearsFreeSpecialOffer />;

        case SpecialOffer.PublicTrustFreeWill.toLowerCase():
            return (
                <a onClick={() => openPromotion("FreePTWillPopup")}>
                    Free Will from Public Trust
                </a>
            );
        case SpecialOffer.nibHealthReward.toLowerCase():
            return (
                <a onClick={() => openPromotion("NibHealthReward")}>
                    Up to $350 Health reward
                </a>
            );
        case SpecialOffer.nibThreeMonths.toLowerCase():
            return (
                <a onClick={() => openPromotion("Nib3Months")}>
                    nib 3 months' free
                </a>
            );
        case SpecialOffer.CignaSpecificInjury.toLowerCase():
            return (
                <a onClick={() => openPromotion("CignaSpecificInjury")}>
                    Free Specific Injury Cover
                </a>
            );
        case SpecialOffer.SouthernCrossGP.toLowerCase():
            return (
                <a onClick={() => openPromotion("SouthernCrossGP")}>
                    Access to unlimited virtual GP consultations with CareHQ
                </a>
            );
        case SpecialOffer.SouthernCrossMH.toLowerCase():
            return (
                <a onClick={() => openPromotion("SouthernCrossMH")}>
                    Complementary annual health check with MedPro and three mental health or wellbeing sessions with Raise
                </a>
            );
        case SpecialOffer.SouthernCrossDiscounts.toLowerCase():
            return (
                <a onClick={() => openPromotion("SouthernCrossDiscounts")}>
                    Access to partnership offers and discounts
                </a>
            );
        case SpecialOffer.FidelityThreeMonths.toLowerCase():
            return (
                <a onClick={() => openPromotion("FidelityThreeMonthsFree")}>
                    Three months free
                </a>
            );
        case SpecialOffer.AIAThreeMonths.toLowerCase():
            return (
                <a onClick={() => openPromotion("AIA3Months")}>
                    Up to 3 months free
                </a>
            );
        case SpecialOffer.AsteronConnectedCare.toLowerCase():
            return (
                <a onClick={() => openPromotion("AsteronConnectedCare")}>
                    Connected Care
                </a>
            );
        case SpecialOffer.FidNoPolicyFee.toLowerCase():
            return (
                <a onClick={() => openPromotion("FidNoPolicyFee")}>
                    No policy fee
                </a>
            );
        case SpecialOffer.AIABestDoctors.toLowerCase():
            return (
                <React.Fragment>
                    <a
                        href="https://www.aia.co.nz/en/help-support/past-product-information/best-doctors.html"
                        target="_blank"
                        rel="noopener">
                        Access to Best Doctors
                    </a>
                    <sup className="text-brand">&reg;</sup>
                    <Icon className="space-pre-m" id="ExternalLink" />
                </React.Fragment>
            );
        case SpecialOffer.AccuroBestDoctors.toLowerCase():
            return (
                <React.Fragment>
                    <a
                        href="https://www.accuro.co.nz/about/active-benefits/best-doctors/"
                        target="_blank"
                        rel="noopener">
                        Access to Best Doctors
                    </a>
                    <sup className="text-brand">&reg;</sup>
                    <Icon className="space-pre-m" id="ExternalLink" />
                </React.Fragment>
            );
        case SpecialOffer.AsteronBestDoctors.toLowerCase():
            return (
                <React.Fragment>
                    <a
                        href="https://www.asteronlife.co.nz/best-doctors.html"
                        target="_blank"
                        rel="noopener">
                        Access to Best Doctors
                    </a>
                    <sup className="text-brand">&reg;</sup>
                    <Icon className="space-pre-m" id="ExternalLink" />
                </React.Fragment>
            );
        case SpecialOffer.AsteronKidsCover.toLowerCase():
            return (
                <a
                    href="https://www.asteronlife.co.nz/documents/kids-cover-brochure.pdf"
                    target="_blank"
                    rel="noopener">
                    Kids cover
                </a>
            );

        default:
            return <React.Fragment>{name}</React.Fragment>;
    }
};

export default React.memo(QuoteSpecialOffers);
